/* eslint-disable import/no-unresolved */
/* eslint-disable import/prefer-default-export */

import StorageService from "src/utils/Storage/storageService";

export interface Partner {
  AFLI: string;
  "Federal Bank": string;
  "IDBI Bank": string;
  "SREI INSURANCE BROKING PRIVATE LIMITED": string;
}
export const partnerCodes: Partial<Partner> = {
  AFLI: "afli",
  "Federal Bank": "federal",
  "IDBI Bank": "idbi",
  "SREI INSURANCE BROKING PRIVATE LIMITED": "srei"
};

export const setLoggedInUserData = async (response: any) => {
  const token = StorageService.getFromLocalStorage("token") || {};
  await Promise.all([
    StorageService.setInLocalStorage("token", {
      ...token,
      accessToken: response?.data?.tokens?.access?.token
    }),
    StorageService.setInLocalStorage("user", response?.data?.user)
  ]);
};

export const samlPartnerIncludes = [partnerCodes["Federal Bank"]];

export const signInMessage: Record<string, string> = {
  AFLI: "Sign in with Microsoft",
  "Federal Bank": "Sign in with SSO",
  "IDBI Bank": "Sign in with Microsoft"
};
